import axios from "axios";

const instance = axios.create({
  baseURL: " https://pragya-tiktok.herokuapp.com/",
});

export default instance;
